import { Radio, RadioGroup } from 'taboola-ultimate-ui';
import { RadioContent } from './components/radioContent/RadioContent';
import styles from './radioCards.module.scss';

export const RadioCards = ({ id, name, selectedValue, onChange, options }) => {
    return (
        <RadioGroup
            id={id}
            name={name}
            selectedValue={selectedValue}
            onChange={onChange}
            className={styles['radios-group']}
        >
            {options?.map(option => (
                <Radio
                    key={option?.id}
                    value={option?.id}
                    title=""
                    labelClassName={`${styles['radio']} ${option?.isDisabled ? styles['disabled'] : ''}`}
                    checkedLabelClassName={styles['checked']}
                    childrenContainerClassName={styles['children-container']}
                    disabled={option?.isDisabled}
                >
                    <RadioContent {...option} />
                </Radio>
            ))}
        </RadioGroup>
    );
};
